import React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import Button from 'shared/components/button/Button';
import Loader from 'features/Loader/Loader';
import NoteHead from './NoteHead';
import { getNote, deleteNote } from './ducks/noteActions';

class NoteView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMode: true
    };
  }

  componentDidMount() {
    this.props.getNote(this.props.match.params.id, this.props.history);
  }

  activateEditMode = event => {
    this.setState({
      showMode: false
    });
  };

  render() {
    if (this.props.noteIsDeleted) {
      return (
        <Redirect
          to={`/clients/${this.props.match.params.client_id}?tab=notes`}
        />
      );
    }

    if (!this.state.showMode) {
      return (
        <Redirect
          to={`/clients/${this.props.match.params.client_id}/notes/${this.props.match.params.id}/edit`}
        />
      );
    }

    if (this.props.loading) {
      return <Loader />;
    } else {
      return (
        <div className="client-form-pages">
          <div className="container">
            <NoteHead
              text="Note"
              clientId={this.props.match.params.client_id}
              history={this.props.history}
            />
            <div className="page-title">
              <h4>Note</h4>
              <div className="title-action">
                <div
                  className="icon-link"
                  onClick={() => this.props.deleteNote(this.props.note.id)}
                >
                  <i className="fas fa-trash"></i>
                </div>
                <Button
                  color="primary"
                  label="Edit"
                  onClick={this.activateEditMode}
                />
              </div>
            </div>
            <div className="add-note-page">
              <div className="form-group">
                <Link
                  to={`/clients/${this.props.match.params.client_id}/notes/${this.props.match.params.id}/edit`}
                >
                  <textarea
                    className="form-control cursor-link"
                    placeholder="Add Note"
                    value={this.props.note ? this.props.note.text : ''}
                    disabled={true}
                  ></textarea>
                </Link>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    note: state.notesReducer.note,
    noteIsDeleted: state.notesReducer.noteIsDeleted,
    loading: state.notesReducer.loading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getNote: (id, history) => dispatch(getNote(id, history)),
    deleteNote: id => dispatch(deleteNote(id))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NoteView);
